import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateRiskMatrix } from '../../features/riskMatrix/riskMatrixSlice'
import { getClientKeyWithAccessToken } from '../../lib/security'

export const useRiskMatrix = (setIsLoading, isLoading) => {
  const riskMatrixState = useSelector((state) => state.riskMatrix)
  const queryState = useSelector((state) => state.riskMatrix.filters)
  const { viewMode, limit, offset, page, status, name } = queryState ? queryState : { ...null }
  const { accessToken } = useSelector((state) => state.login)
  const dispatch = useDispatch()

  useEffect(() => {
    if (isLoading) {
      const baseUrlRoles = `${process.env.REACT_APP_BASEURL}/riskmatrix`
      let url = buildUrl(baseUrlRoles)

      function buildUrl(baseUrl) {
        let url = `${baseUrl}?viewMode=${viewMode}&limit=${limit}&page=${page}&offset=${offset}`

        if (status?.length) url += `&status=${status}`

        if (name?.length) url += `&name=${name}`

        return url
      }

      getClientKeyWithAccessToken(accessToken)
        .then((clientKey) => {
          return fetch(process.env.REACT_APP_IS_DEMO ? '../../data/riskMatrixs.json' : url, {
            method: 'GET',
            headers: {
              Authorization: `Bearer ${accessToken}`,
              'client-key': clientKey,
            },
          })
        })
        .then((res) => res.json())
        .then((res) => {
          if (res) {
            const { data, pagination } = res
            const aux = { data, pagination }
            dispatch(updateRiskMatrix(aux))
            setIsLoading(false)

            if (!res.data?.length) {
              dispatch(updateRiskMatrix([]))
              setIsLoading(false)
            }
          }
        })
        .catch((error) => {
          console.error('[HOOK: useRiskMatrix] --> ', error)
          setIsLoading(false)
        })
    }
  }, [isLoading, queryState])

  return riskMatrixState
}
